import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EquipmentService } from 'app/services/models/equipment.service';
import { KindService } from 'app/services/models/kind.service';
import { ProjectService } from 'app/services/models/project.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-equipment-dialog',
  templateUrl: './equipment-dialog.component.html',
  styleUrls: ['./equipment-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EquipmentDialogComponent implements OnInit {
  @Input() data: number;

  equipmendForm: FormGroup;
  kinds: any[] = []
  projects: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private kindSerivce: KindService,
    private equipmentService: EquipmentService,
    private projectService: ProjectService) { }

  async ngOnInit() {
    this.equipmendForm = this.fb.group({
      name: [null, Validators.required],
      description: [null],
      seriNo: [null],
      isActive: [true, Validators.required],
      kindId: [null, Validators.required],
      projectId: [null]
    });
    await this.getAllKinds();
    await this.getAllProjects();
    if (this.data) {
      await this.getByIdEquipment(this.data);
    }
  }

  async getByIdEquipment(id) {
    const data = await this.equipmentService.getByIdEquipment(id);
    console.log(data);
    this.equipmendForm.patchValue({
      name: data.name,
      description: data.description,
      seriNo: data.seriNo,
      isActive: data.isActive,
      kindId: data.kindId,
      projectId: data.projectId
    });
  }

  async getAllProjects() {
    const data = await this.projectService.getAllProject(0, 1000, '', 1);
    console.log(data);
    this.projects = data.projects;
  }

  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 1000, 15);
    console.log(data);
    this.kinds = data.types;
  }

  async submit() {
    if (this.equipmendForm.invalid) {
      this.equipmendForm.markAllAsTouched();
      this.toastrService.error('Lütfen formu eksiksiz doldurunuz.', 'Hata');
      return;
    }

    let formData = this.equipmendForm.value;
    console.log('Form verisi:', formData);

    if (this.data) {
      formData = {
        id: this.data,
        ...formData
      };
      const data = await this.equipmentService.updateEquipment(formData);
      if (data.status) {
        this.toastrService.success(data.message);
        this.equipmentService.sendEvent(true);
        this.activeModal.close();
      } else {
        this.toastrService.error(data.message);
      }
    } else {
      const data = await this.equipmentService.createEquipment(formData);
      if (data.status) {
        this.toastrService.success(data.message);
        this.equipmentService.sendEvent(true);
        this.activeModal.close();
      } else {
        this.toastrService.error(data.message);
      }
    }
  }
  closeModal() {
    this.activeModal.close();
  }
}
